import { cn } from "@/lib/utils";

export const Logo = ({ className, variant = "auto" }) => {
  if (variant === "red") return <img src="/logo-red.png" alt="Doble R Records" className={cn("object-contain", className)} data-testid="brand-logo-img" />;
  return (
    <>
      <img src="/logo-black.png" alt="Doble R Records" className={cn("object-contain dark:hidden", className)} data-testid="brand-logo-img" />
      <img src="/logo-white.png" alt="" aria-hidden className={cn("object-contain hidden dark:block", className)} />
    </>
  );
};
